export default "__VITE_ASSET__BYaSS8Hp__"